import React from 'react';

export const ToastContext = React.createContext();

export const useToasts = () => React.useContext(ToastContext);
